export default __webpack_public_path__ + "static/media/email.63876cd9.svg";